import api from "@/libs/axios";
import { QueryConfig } from "@/libs/query";
import { QUERY_KEY } from "@/pages/taskpane/shared/constants/queryKey";
import { apiEnum } from "@/pages/taskpane/shared/types/enums/apiEnum";
import { useQuery } from "@tanstack/react-query";
import { IAttendeeInfo, IGetAttendeeStatusRequest } from "./types/attendeeEntity";

export const getAttendeeStatus = async (
  payload: IGetAttendeeStatusRequest
): Promise<Record<string, IAttendeeInfo>> => {
  const { data } = await api.post(apiEnum.getAttendeeStatus, payload);
  return data.data?.usersAvailability || {};
};

/**
 * Query options for selected resource
 */
export const optionsAttendeeStatus = (payload: IGetAttendeeStatusRequest) => ({
  queryKey: [
    QUERY_KEY.GET_ATTENDEE_STATUS,
    {
      userEmails: payload.userEmails?.sort().join(',') || '',
      occurrences: JSON.stringify(payload.occurrences),
      interval: payload.interval,
      timeZoneStandardName: payload.timeZoneStandardName,
      isRecurring: payload.isRecurring,
      timeZoneOccurrence: payload.timeZoneOccurrence,
    },
  ],
  queryFn: () => {
    return getAttendeeStatus(payload);
  },
  // Cache strategy
  staleTime: 2 * 60 * 1000, // Cache fresh for 2 minutes
  gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes after unmount
});

type GetAttendeeStatusType = {
  queryConfig?: QueryConfig<typeof optionsAttendeeStatus>;
  payload: IGetAttendeeStatusRequest;
  enabled?: boolean;
};


export const useGetAttendeeStatus = ({ queryConfig, payload, enabled = true }: GetAttendeeStatusType) => {
  const query = useQuery({
    ...optionsAttendeeStatus(payload),
    ...queryConfig,
    enabled: enabled,
  });
  return query;
};
